import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AboutAqaixComponent} from './about-aqaix/about-aqaix.component';
import {AboutBlogComponent} from './about-blog/about-blog.component';
import {AboutBuyComponent} from './about-buy/about-buy.component';
import {AboutPlatformComponent} from './about-platform/about-platform.component';
import {AboutStandardsComponent} from './about-standards/about-standards.component';

const aboutRoutes: Routes = [
  {
    path: 'about-aqaix',
    component: AboutAqaixComponent
  },
  {
    path: 'about-blog',
    component: AboutBlogComponent
  },
  {
    path: 'about-buy',
    component: AboutBuyComponent
  },
  {
    path: 'about-platform',
    component: AboutPlatformComponent
  },
  {
    path: 'about-standards',
    component: AboutStandardsComponent
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(aboutRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AboutRoutingModule {
}
